/** Phoenix replays the channel's join reply, carrying the same pending rows, on every rejoin. */
const surfaced = new Set<string>();

/**
 * Claims a message as surfaced, so only the first caller for an id raises its toast.
 *
 * @param id the recipient id, which is also the toast's external id
 * @returns whether this call is the one that surfaces it
 */
export const claimSurfaced = (id: string): boolean => {
  if (surfaced.has(id)) return false;

  surfaced.add(id);

  return true;
};

export const resetSurfacedMessages = (): void => {
  surfaced.clear();
};
